<mat-form-field appearance="outline">
  <input matInput #input
    placeholder="Search"
    [formControl]="searchControl"
    (keydown)="onKeydown($event, input)"
  />
</mat-form-field>
